
import React, {Component} from "react";

import SelectCircleMemberCard from "./select-circle-member-card.js";

import "./select-circle-member.css";


class SelectCircleMember extends Component {

    constructor(props) {
        super(props);

        this.COLORS = [
            "rgb(240, 76, 88)",
            "rgb(118, 193, 93)",
            "rgb(10, 158, 204)",
            "rgb(234, 171, 78)",                    
            "rgb(204, 10, 198)",
            "rgb(27, 213, 187)",
            "rgb(236, 223, 70)",
            "rgb(185, 105, 105)",   
            "rgb(76, 240, 89)"
        ];


        this.state = {
            selected_circle_member: false
        }
    }

    printCircleMembers() {
        let {circle_members} = this.props;


        let circleMembers = circle_members;
        let myself = {
            id: -1,
            first_name: "Just",
            last_name: "Me"
        };

        let className = "select_circle_member_cards_grid"; 


        if (circleMembers.length < 3) {
            className = "select_circle_member_cards_centered"
        }

        let that = this;

        let index = 0;
        let myselfColorIndex = index % that.COLORS.length;
        let myselfColor = that.COLORS[myselfColorIndex];
        index++;
        return (
            <div className={className}>
                <SelectCircleMemberCard circle_member={myself} select_func={this.circleMemberSelected.bind(this)} color={myselfColor}/>
                {
                circleMembers.map((circleMember) => {
                    let colorIndex = index % that.COLORS.length;
                    let color = that.COLORS[colorIndex];
                    index++;
                    return <SelectCircleMemberCard circle_member={circleMember} select_func={this.circleMemberSelected.bind(this)} color={color} />
                })
                }
                
            </div>
        )
    }


    circleMemberSelected (circleMember) {
        let {circle_member_selected_func} = this.props;
        this.setState({
            selected_circle_member: circleMember
        })


        circle_member_selected_func(circleMember);
    }

    render () { 
        return (
            <div className='select_circle_member_container'>
                <div className='select_circle_member_title'>Who is playing with you today?</div>
                <div className='select_circle_member'>
                    {this.printCircleMembers()}
                </div>
            </div>
        )
    }
}

export default SelectCircleMember;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/select-circle-member/select-circle-member.js